import request from "@/axios";

/** 分页查询升级黑名单 */
export const getUpgradeBlacklistList = (params) => {
  return request({
    url: "/lebo-addition/web/upgradeBlacklist/page",
    method: "get",
    params
  });
};

/** 保存升级黑名单 */
export const addUpgradeBlacklist = (data) => {
  return request({
    url: "/lebo-addition/web/upgradeBlacklist/save",
    method: "post",
    data
  });
};

/** 更新升级黑名单 */
export const updateUpgradeBlacklist = (data) => {
  return request({
    url: "/lebo-addition/web/upgradeBlacklist/update",
    method: "post",
    data
  });
};

/** 删除升级黑名单 */
export const deleteUpgradeBlacklist = (channelIds) => {
  return request({
    url: "/lebo-addition/web/upgradeBlacklist/delete",
    method: "post",
    params: { channelIds }
  });
};

/** Excel导入升级黑名单 */
export const importUpgradeBlacklist = (file, remark = '') => {
  const formData = new FormData();
  formData.append('file', file);
  if (remark) {
    formData.append('remark', remark);
  }
  return request({
    url: "/lebo-addition/web/upgradeBlacklist/import",
    method: "post",
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

/** 根据渠道ID查询升级黑名单 */
export const getUpgradeBlacklistByChannelId = (channelId) => {
  return request({
    url: "/lebo-addition/web/upgradeBlacklist/getByChannelId",
    method: "get",
    params: { channelId }
  });
};

/** 下载升级黑名单录入模板 */
export const downloadUpgradeBlacklistTemplate = () => {
  return request({
    url: "/lebo-addition/web/upgradeBlacklist/exportUids",
    method: "get",
    responseType: 'blob' // 重要：设置响应类型为blob以处理文件下载
  });
};